import React from 'react';

import {faCirclePlus} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icon from 'components/Icon/Icon';
import {TableFactory} from 'components/TableFactory/TableFactory';
import './PageEditorDesktop.scss';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setPageEditorFiltersAC} from 'pages/pubPagesView/store/pubPageSlice';
import PageEditor from 'typescript/models/PageEditor';
import {handleQueryDirection} from 'utils/helpers/handleQueryDirection';

import {PageEditorsBody} from './PageEditorsBody';

interface IProps {
  pubEditors: PageEditor[];
  isAdmin?: boolean;
  handleAssign?: () => void;
}

export const PageEditorDesktop = ({pubEditors, isAdmin = false, handleAssign}: IProps) => {
  const dispatch = useSetGlobalState();

  const {
    pubEditors: {filters},
  } = useGlobalState((state) => state.pubPage);

  const handleSort = (column: 'nickname') => {
    const direction = handleQueryDirection(column, filters);

    dispatch(setPageEditorFiltersAC({...filters, column, direction}));
  };

  const formatHeaderCells = () => {
    const tableHeaderCells = [
      {
        name: 'Nickname',
        cellClass: `pub-page-editors-table__head-col ${!isAdmin ? 'pub-page-editors-table__head-col--manager' : ''}`,
        sort: (
          <button
            className="pub-pages-table__sort"
            title="Sort page editors by nickname"
            onClick={() => handleSort('nickname')}
          >
            <Icon icon="sort-2" />
          </button>
        ),
      },
      {
        name: 'Email',
        cellClass: `pub-page-editors-table__head-col ${!isAdmin ? 'pub-page-editors-table__head-col--manager' : ''}`,
      },
      {
        name: 'Phone Number',
        cellClass: `pub-page-editors-table__head-col ${!isAdmin ? 'pub-page-editors-table__head-col--manager' : ''}`,
      },
    ];

    const payload = isAdmin
      ? [
          ...tableHeaderCells,
          {
            name: ' ',
            cellClass: `pub-page-editors-table__head-col ${
              !isAdmin ? 'pub-page-editors-table__head-col--manager' : ''
            }`,
            content: isAdmin ? (
              <button title="Assign page editor to pub" onClick={handleAssign}>
                <FontAwesomeIcon icon={faCirclePlus} />
              </button>
            ) : undefined,
          },
        ]
      : tableHeaderCells;

    return payload;
  };

  const tableFactoryProps = {
    table: {className: 'pub-page-editors-table'},
    tableHeader: {className: 'pub-page-editors-table__head'},
    tableHeaderCells: formatHeaderCells(),
    tableBody: <PageEditorsBody pubEditors={pubEditors} isAdmin={isAdmin} />,
  };

  return (
    <div className="pub-page-editors">
      <TableFactory {...tableFactoryProps} />
    </div>
  );
};
